<template>
  <div class="itemList">
    <div class="itemList__listing">
      <div class="listview">
        <table>
          <thead class="none">
            <tr>
              <td class="listview__title items">COLLECTION</td>
              <td class="listview__title placement">ADDED TO GROUP</td>
              <td class="listview__title visitor">TOTAL LISTING</td>
              <td class="listview__title price">VISIBILITY</td>
              <td class="save"></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in items" :key="index" class="content" @click.stop="listClick(item)">
              <td class="items">
                <div class="item">
                  <img v-if="item.thumbnail_square" :src="item.thumbnail_square" alt="">
                  <img v-else :src="`/img/notfound/img-placeholder_square.jpg`" alt="">
                  <div class="stack">
                    <span class="title">{{item.title}}</span>
                    <span class="location">{{item.remarks}}</span>
                  </div>
                </div>
              </td>
              <td class="placement none"><span>{{ groupList(item.group_list) }}</span></td>
              <td class="visitor none"><span>{{ item.item_count }} items</span></td>
              <td class="visibilty-action">
                <div class="visibilty-action__wrapper">
                  <div class="visibility">
                    <adx-selectdropdown :itemId="item.id" @selected="selected" :value.sync="item.status" :label="`Visibility`" :options="dropdown" />
                  </div>
                </div>
              </td>
              <td class="icon-list" @click.stop="addCollection(item)">
                <adx-tooltip text="Add to collection">
                  <span slot="content">
                    <adx-loading-secondary v-if="isLoading.includes(item.id)"/>
                    <button v-if="!isLoading.includes(item.id)" class="btn-small secondary">Add</button>
                  </span>
                </adx-tooltip>
              </td>
            </tr>
          </tbody>
          <slot name="infiniteLoading"/>
        </table>
      <div class="emptyState">
        <adx-empty-selection v-if="isEmpty && !loading"/>
      </div>
      <div class="listview__loadingWrapper">
        <slot name="loading" />
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from '@/components/Tooltip'
import MenuExpansion from '@/components/MenuExpansion'
import EmptySelection from '@/components/NotFound/Selection'
import LoadingSecondary from '@/components/Loading/Secondary'
import SelectDropdown from '@/components/Form/SelectDropdown'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { mapGetters, mapActions, mapMutations } from 'vuex'


export default {
    name: 'adx-listaddmore-collection',
    components: {
      'adx-tooltip': Tooltip,
      'adx-menu-expansion': MenuExpansion,
      'adx-empty-selection': EmptySelection,
      'adx-loading-secondary': LoadingSecondary,
      'adx-selectdropdown': SelectDropdown,
    },
    props: {
      items: {
        required: false
      },
      loading: {
        required: false
      },
      headers: {
        required: false
      },
      channel: {
        required: false
      },
    },
    data () {
      return {
        isEmpty: false,
        isLoading: [],
        dropdown: [
        {
          label: 'Public',
          value: 'Public'
        },
        {
          label: 'Private',
          value: 'Private'
        }
      ],
      }
    },
    computed: {
      ...mapGetters ({
        defaultSaved: 'default',
        token: 'token'
      }),
    },
    watch: {

    },
    beforeCreate() {

    },
    created() {

    },
    beforeMount() {

    },
    mounted() {
      
    },
    beforeUpdate() {

    },
    updated() {
      if(this.items == 0) {
        this.isEmpty = true
      }else {
        this.isEmpty = false
      }
    },
    activated() {

    },
    deactivated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      addCollection(item) {
        (async () => {
          const data = {
            collections_id: [item.id]
          }
          this.isLoading.push(item.id)
          const group_id = this.$route.params.id
          const response = await api.post(apiV2.collectionGroupAddCollection(group_id), data, { needToken: true })
          
          this.$emit('reloadData')
          this.isLoading = []
        })();
      },
      groupList(item) {
        return item ? item.join(',') : 'None'
      },
      remarksList(item) {
        return item ? item.join(',') : 'None'
      },
      selected(item) {
        (async () => {
          const data = {
            id: item.id,
            visibility: item.item.value == 'Public' ? true : false
          }
          const response = await api.patch(apiV2.collectionDetail(item.id), data, { needToken: true })
          this.$notify({
            group: 'saved',
            title: 'Update Visibility Success',
            text: `${response.data.title} has been successfully changed to ${response.data.status}`,
            type: 'success'
          })
        })();
      },
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
